import { useEffect, useState } from 'react';
import { AlarmClock } from 'lucide-react';
import { api } from '../../../lib/auth';
import { useTranslation } from '../../../lib/i18n';

let cache = null;
const loadThreshold = () => {
  cache = cache || api.get('/planning/start-stop/reminder-threshold').then((r) => r.data?.data).catch(() => { cache = null; return null; });
  return cache;
};

export function OverdueStopBanner({ startIso, onStop, testId }) {
  const { t } = useTranslation();
  const [cfg, setCfg] = useState(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { loadThreshold().then(setCfg); }, []);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(t); }, []);
  if (!cfg?.enabled || !startIso) return null;
  const hours = (now - new Date(startIso).getTime()) / 3600000;
  if (hours < cfg.hours_after_start) return null;
  return (
    <div className="rounded-2xl bg-rose-600 text-white p-4 flex items-center gap-3 shadow-lg shadow-rose-600/30 animate-in fade-in duration-300" role="alert" data-testid={testId}>
      <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/20">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <AlarmClock className="relative h-6 w-6" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="font-black leading-tight">{t('startStop.overdueTitle')}</p>
        <p className="text-xs opacity-90">{t('startStop.overdueBody', { h: Math.floor(hours) })}</p>
      </div>
      <button type="button" onClick={onStop} className="shrink-0 h-10 px-4 rounded-xl bg-white text-rose-700 font-black" data-testid={`${testId}-stop`}>STOP</button>
    </div>
  );
}
